import { Injectable } from '@angular/core';
import { Taxonomy, TaxonomySearchResult } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';
import { StorageUtilityLib } from '../util';

@Injectable({
  providedIn: 'root',
})
export class TaxonomyConfigService {
  private taxonomyObject: AnyType = {};

  constructor(private storageUtility: StorageUtilityLib) {}

  setConfig(taxonomies: TaxonomySearchResult): void {
    if (taxonomies.result && taxonomies.result.length > 0) {
      taxonomies.result.forEach((taxonomy: Taxonomy) => {
        const categoryName = taxonomy.categoryName;
        if (!this.taxonomyObject[categoryName]) {
          this.taxonomyObject[categoryName] = [];
        }
        this.taxonomyObject[categoryName].push({
          _id: taxonomy._id,
          name: taxonomy.name,
          linkableArray: taxonomy.linkableArray,
          removedFlag: taxonomy.removedFlag,
        });
      });
      this.storageUtility.setLocalStorage('taxonomyConfig', this.taxonomyObject);
      return this.taxonomyObject;
    }
  }

  getConfig(categoryName?: string): AnyType {
    const taxonomies: AnyType = this.storageUtility.getLocalStorage('taxonomyConfig');
    if (categoryName) {
      return taxonomies[categoryName] ? taxonomies[categoryName] : [];
    }
    return taxonomies;
  }
}
